module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Bold-b023d776e1732fbecc8b4c084b8cce19.svg";